import { modals } from '@mantine/modals';
import { i18nKeys, useTranslation } from 'locales';
import qs from 'query-string';
import { ExportCsv } from 'shared/components/ExportCsv';
import { useLoadFieldCatalogue } from 'shared/hooks/use-load-field-catalogue';
import { appActions } from 'store/app/app.actions';

type ExportFormValues = {
  attributes: Record<string, boolean>;
  export_with_filters: boolean;
};

export const ExportPaymentPlansCsv = () => {
  const { t } = useTranslation();
  const { fieldCatalogue } = useLoadFieldCatalogue({ viewType: 'payment_plans' });

  const exportFields = fieldCatalogue
    .filter(({ key, displayable }) => displayable && key !== 'actions')
    .map(({ key, label }) => ({ value: key, description: label }));

  const downloadCsv = (data: ExportFormValues) => {
    appActions.export({
      data: {
        ...data,
        ...(data.export_with_filters ? qs.parse(location.search) : {}),
        view_id: location.hash.slice(1),
        resource_type: 'payment_plan',
        type: 'csv',
      },
      noLoading: true,
    });
    modals.closeAll();
  };

  return (
    <ExportCsv
      downloadCsv={downloadCsv}
      resourceType="payment_plan"
      allFields={exportFields}
      wrappers={[
        {
          name: 'selectPaymentPlanInfo',
          fields: exportFields,
          text: t(i18nKeys.PAYMENT_PLAN.TITLE.ONE),
        },
      ]}
      selectAllLabel={t(i18nKeys.INVOICING.EXPORT_CSV.EXPORT_ALL_PAYMENT_PLANS)}
      selectFilteredLabel={t(i18nKeys.INVOICING.EXPORT_CSV.EXPORT_FILTERED_PAYMENT_PLANS)}
    />
  );
};
